import { FormInputDropdown } from '@AMIEWEB/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputDropdown';
import { selectOrderReason } from '@AMIEWEB/Order/Store/OrderCreation.selectors';
import React from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

export const OrderReason = () => {
  const { t } = useTranslation();
  const orderReason = useSelector(selectOrderReason);
  const { control, register, setValue } = useFormContext();
  const reason = useWatch({ name: 'orderReason' });
  register('orderReasonId');

  return (
    <Controller
      control={control}
      name={'orderReason'}
      render={({ field }) => (
        <FormInputDropdown
          name={'orderReason'}
          label={t('order.newOrderCreation.tabs.orderTypeDetail.orderReason')}
          standard={true}
          inputValue={reason ?? null}
          options={orderReason ?? []}
          handleChange={e => {
            field.onChange(e);
            setValue('orderReasonId', orderReason.find(item => item.Description === e.target.value)?.ID, { shouldValidate: true });
          }}
          isOrderCreationElement={true}
        />
      )}
    />
  );
};
